exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (max-width: 992px) {\n}\n.container[data-v-6384931e] {\n    /* margin-right: auto;\n    margin-left: auto; */\n    width: 100%;\n    /* margin: 0 auto; */\n}\n.panel2[data-v-6384931e], .panel21[data-v-6384931e] {\n    background: #fcfcfc;\n    border: solid 1px #dbdbdb;\n    /*margin-bottom: 5%;*/\n    padding-bottom: 25px;\n    padding-top: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    float: left;\n    width: 100%;\n}\n*[data-v-6384931e] {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n.orangeConfirmationButton[data-v-6384931e] {\n  margin-top: 10%;\n}\n@media (max-width:  768px) {\n.col-md-3[data-v-6384931e] {\n    margin-top: -20px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6384931e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/contacts/CMContactDetail.vue
// module id = 1143
// module chunks = 2